import { CommonResponse, HrmsEmployeeDetailsDto } from '@gtpl/shared-models/masters';
import { forwardRef, Inject, Injectable } from '@nestjs/common';
import appSettings from 'apps/services/config';
import { getManager } from 'typeorm';
import { ApplyForLeavesService } from '../apply-for-leaves/apply-for-leaves.service';
import { EmployeeLeavesCreateDTO } from './dto/employee-leaves-create.dto';
import { EmployeeLeavesAdapter } from './dto/employee-leaves.adapter';
import { EmployeeLeaves } from './entity/employee-leaves.entity';
import { EmployeeLeavesRepository } from './entity/employee-leaves.repository';
import { DepartmentService, EmployeeService } from '@gtpl/shared-services/masters';
import { TypesOfLeavesService } from '../types-of-leaves/types-of-leaves.service';
import { GetEmpLeaves } from './dto/get-emp-leaves.dto';
import { EmpLeavesResponse, EmployeeLeavesColumns, EmployeeLeavesResponse, GetAllAvailableLeavesResponseModel, TypesOfLeavesDto } from '@gtpl/shared-models/hrms';
import { LeavesDTO } from './dto/leaves.dto';
import { EmpLeaveDTO } from './dto/emp-leaves.dto';
import { GetEmpAvlLeaves } from './dto/get-emp-avl-leaves.dto';
import { UpdateEmpAvlLeaves } from './dto/update-emp-consumed-leaves.dto';
import { EmployeeGetLeavesDto } from 'libs/shared-models/hrms/src/lib/employee-leaves/employee-leaves-dto';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { EmployeeLeavesLog } from './entity/employee-leaves-log.entity';
import { TypesOfLeavesRepository } from '../types-of-leaves/repo/types-of-leaves.repository';

@Injectable()
export class EmployeeLeavesService {
    constructor(
        private employeeLeavesRepository: EmployeeLeavesRepository,
        private employeeLeavesAdapter: EmployeeLeavesAdapter,
        @Inject(forwardRef(() => ApplyForLeavesService))
        private applyLeves: ApplyForLeavesService,
        private empService: EmployeeService,
        private leaveTypesService: TypesOfLeavesService,
        private departmentService: DepartmentService
        

    ) { }

    // async createEmployeeLeaves(createDto: EmployeeLeavesCreateDTO): Promise<CommonResponse> {
    //     const dataToBeSaved: EmployeeLeaves[] = []
    //     for (const empLeavData of createDto.empLeaveData) {
    //         for (const leaves of empLeavData.leaves) {
    //             const entityObj = new EmployeeLeaves();
    //             if (leaves.empleavesId) {
    //                 entityObj.employeeLeavesId = leaves.empleavesId;
    //             }
    //             entityObj.employeeId = empLeavData.employeeId;
    //             entityObj.year = empLeavData.year;
    //             entityObj.typeOfLeave = leaves.typeOfLeave;
    //             entityObj.leavesAlloted = leaves.leavesAlloted;
    //             const consumed = await this.applyLeves.getAllConsumedLeavesByLeaveTypeAndEmpId(empLeavData.employeeId, empLeavData.year, leaves.typeOfLeave);
    //             console.log(consumed)
    //             entityObj.leavesUsed = consumed;
    //             entityObj.leavesAvailable = Number(leaves.leavesAlloted) - Number(consumed);
    //             entityObj.dateTime = createDto.dateTime;
    //             entityObj.createdUser = createDto.createdUser;
    //             dataToBeSaved.push(entityObj);
    //         };
    //     };
    //     console.log(dataToBeSaved)
    //     await this.employeeLeavesRepository.save(dataToBeSaved, { chunk: 100 })
    //     return new CommonResponse(true, 1001, "Leaves alloted Successfully. ");
    // }

    async createEmployeeLeaves(formData: any): Promise<CommonResponse> {
        console.log(formData, 'oooooooser');
        const transactionManager = new GenericTransactionManager();
        try {
            await transactionManager.startTransaction();
            const flag = new Set<boolean>();
            const columnArray = [];
            const updatedArray = formData.data.map((obj) => {
                const updatedObj = {};
                for (const key in obj) {
                    const newKey = key
                        .replace(/\s/g, '')
                        .replace(/[\(\)\.]/g, '')
                        .replace(/-/g, '');
                    if (newKey != '') {
                        columnArray.push(newKey);
                        updatedObj[newKey] = obj[key];
                    }
                }
                return updatedObj;
            });
            const difference = columnArray.filter(
                (element) => !EmployeeLeavesColumns.includes(element)
            );
            console.log(difference, '----');
            if (difference.length > 0) {
                await transactionManager.releaseTransaction();
                return new CommonResponse(
                    false,
                    1110,
                    "Excel columns doesn't match. Please attach the correct file."
                );
            }
            const convertedData = updatedArray.map((obj) => {
                const updatedObj = {};
                for (const key in obj) {
                    const value = obj[key];
                    if (value === '') {
                        updatedObj[key] = null;
                    } else {
                        updatedObj[key] = value;
                    }
                }
                return updatedObj;
            });
            for (const data of convertedData) {
                // let dtoData
                const manager = getManager()
                const getDataEmployeeDetails = `SELECT employee_id FROM ${appSettings.masters_db}.employee_details WHERE employee_code = '${data.EmployeeCode}'`;
                const result = await manager.query(getDataEmployeeDetails);
                console.log(result,'mmmmmmmmmmm')
                if (data.EmployeeCode != null) {
                    const existedData = await this.employeeLeavesRepository.findOne({
                        where: {

                            employeeId: result[0].employee_id,
                        },
                    });
                    if (existedData) {

                        const update = await transactionManager.getRepository(EmployeeLeaves)
                            .update({ employeeLeavesId: existedData.employeeLeavesId }, {});
                        if (!update.affected) {
                            flag.add(false);
                            await transactionManager.releaseTransaction();
                            return new CommonResponse(
                                false,
                                0,
                                'Something went wrong in updating existing record'
                            );
                        } else {
                            const manager=getManager()
                            const getDataEmployeeDetails = `SELECT employee_id FROM ${appSettings.masters_db}.employee_details WHERE employee_code = '${data.EmployeeCode}'`;
                        const result = await manager.query(getDataEmployeeDetails);
                            const logData = []
                            for (const [index, rec] of ["Sick leave", "Casual Leave", "Privilege Leave"].entries()) {
                            const logs = new EmployeeLeavesLog();
                        const getLeaveTypess = await transactionManager.getCustomRepository(TypesOfLeavesRepository).findOne({ select: ['typeOfLeaveId'], where: { typeOfLeave: rec } })
                        const currentYear = new Date().getFullYear().toString();
                            logs.employeeId = result[0].employee_id;
                            logs.typeOfLeave = getLeaveTypess.typeOfLeaveId;
                            logs.leavesAlloted =  data[rec.replace(' ', '')]
                            logs.leavesUsed = 0
                            logs.year=currentYear
                            logs.leavesAvailable =  data[rec.replace(' ', '')]
                            logs.employeeLeavesLogId = existedData.employeeLeavesId
                            logData.push(logs)
                            }

                            const addupdatedData = await transactionManager.getRepository(EmployeeLeavesLog).save(logData);
                            if (addupdatedData) {
                                flag.add(true);
                            } else {
                                flag.add(false);
                                await transactionManager.releaseTransaction();
                                break;
                            }
                        }
                    }
                    else {
                        const manager = getManager()
                        console.log('resultresultresultresultresult')

                        const getDataEmployeeDetails = `SELECT employee_id FROM ${appSettings.masters_db}.employee_details WHERE employee_code = '${data.EmployeeCode}'`;
                        const result = await manager.query(getDataEmployeeDetails);
                        console.log(result, 'resultresultresultresultresult')
                        const saveingData = []
                        for (const [index, rec] of ["Sick leave", "Casual Leave", "Privilege Leave"].entries()) {
                            console.log(data, 'hhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhhh', rec)
                            const addObj = new EmployeeLeaves();
                            const getLeaveTypess = await transactionManager.getCustomRepository(TypesOfLeavesRepository).findOne({ select: ['typeOfLeaveId'], where: { typeOfLeave: rec } })
                            const currentYear = new Date().getFullYear().toString();
                            addObj.createdUser = formData.user
                            addObj.employeeId = result[0].employee_id;
                            addObj.typeOfLeave = getLeaveTypess.typeOfLeaveId;
                            addObj.leavesAlloted = data[rec.replace(' ', '')]
                            addObj.leavesUsed = 0
                            addObj.leavesAvailable = data[rec.replace(' ', '')]
                            addObj.year = currentYear
                            saveingData.push(addObj);
                        }

                        // addObj.weekOffDay = data.WeekOfDay
                        const addSave = await transactionManager.getRepository(EmployeeLeaves).save(saveingData);
                        if (addSave) {
                            flag.add(true);
                        } else {
                            flag.add(false);
                            await transactionManager.releaseTransaction();
                            return new CommonResponse(false, 0, 'Somthing went wrong in saving the data');
                        }
                    }
                }
            }
            if (!flag.has(false)) {
                await transactionManager.completeTransaction();
                return new CommonResponse(true, 1, 'Data saved successfully');
            } else {
                return new CommonResponse(false, 652, 'Something went wrong');
            }
        } catch (err) {
            await transactionManager.releaseTransaction();
            return new CommonResponse(false, 0, err.message);
        }
    }
    
    
    
    
    
    async getAllEmployeeLeaves(getDto: GetEmpLeaves): Promise<EmpLeavesResponse> {
        try {

            const leaveTypes = await this.leaveTypesService.getAllActiveTypesOfLeaves();
            const employeeDataRes = await this.empService.getAllActiveEmployeesForLeaves();
            const empLeavesMap = await this.getEmpleavesMap(getDto.year, leaveTypes.data);
            const employeeData = [];
            // console.log("employeeDataRes")
            // console.log(employeeDataRes)
            for (const employee of employeeDataRes.data) {
                console.log(employee);
                console.log("*****************************************************************");
                const deptDetails = this.departmentService.getDeptDataById({ deptId: Number(employee.departmentId) });
                let dept;
                await Promise.all([deptDetails,]).then((res) => {
                    dept = res[0].status ? res[0].data.deptName : null;
                })
                const emplDto = new EmpLeaveDTO();
                emplDto.employeeId = employee.employeeId;
                emplDto.employeeCode = employee.employeeCode;
                emplDto.employeeName = employee.employeeName;
                emplDto.designation = employee.designation;
                emplDto.status = employee.status;
                emplDto.year = getDto.year;
                emplDto.gender = employee.gender;
                emplDto.departmentId = employee.departmentId;
                emplDto.departmentName = dept;
                emplDto.employeeLastName = employee.employeeLastName;
                const leaves = [];
                leaveTypes.data.forEach(leaveType => {
                    if (empLeavesMap.get(employee.employeeId)) {
                        leaves.push(empLeavesMap.get(employee.employeeId).get(leaveType.typeOfLeaveId));
                    } else {
                        const leavesDto = new LeavesDTO();
                        leavesDto.leavesAlloted = leaveType.defaultLeaves;
                        leavesDto.leavesAvailable = leaveType.defaultLeaves;
                        leavesDto.leavesUsed = 0;
                        leavesDto.typeOfLeave = leaveType.typeOfLeaveId;
                        leaves.push(leavesDto)
                    }
                })
                emplDto.leaves = leaves;
                employeeData.push(emplDto);
                console.log(emplDto);
            }
            console.log("employeeData");
            console.log(employeeData);
            console.log("&&&&&&&&&&&&")
            if (employeeData.length > 0) {
                return new EmpLeavesResponse(true, 123, 'Leavse data retireved', employeeData);
            }
            else {
                return new EmpLeavesResponse(false, 1110, 'No data found',);
            }
        }
        catch (err) {
            console.log(err);
            throw err
        }
    }

    async getEmpleavesMap(year: string, typesOfLeaves: TypesOfLeavesDto[]) {
        const empLeaveDataMap: Map<number, Map<number, LeavesDTO>> = new Map();
        const empLeaveDataQueryRes = await this.employeeLeavesRepository.find({ where: { year: year } });
        empLeaveDataQueryRes.forEach(empLeavedata => {
            if (!empLeaveDataMap.has(empLeavedata.employeeId)) {
                empLeaveDataMap.set(empLeavedata.employeeId, new Map());
            }
            typesOfLeaves.forEach(leaveTypes => {
                if (!empLeaveDataMap.get(empLeavedata.employeeId).has(leaveTypes.typeOfLeaveId)) {
                    const leavesDto = new LeavesDTO();
                    leavesDto.leavesAlloted = leaveTypes.defaultLeaves;
                    leavesDto.leavesAvailable = leaveTypes.defaultLeaves;
                    leavesDto.leavesUsed = 0;
                    leavesDto.typeOfLeave = leaveTypes.typeOfLeaveId;
                    empLeaveDataMap.get(empLeavedata.employeeId).set(leaveTypes.typeOfLeaveId, leavesDto);
                }
            });
            const leaveDto = empLeaveDataMap.get(empLeavedata.employeeId).get(empLeavedata.typeOfLeave);
            if (leaveDto) {
                leaveDto.leavesAlloted = empLeavedata.leavesAlloted;
                leaveDto.leavesAvailable = empLeavedata.leavesAvailable;
                leaveDto.leavesUsed = empLeavedata.leavesUsed;
                leaveDto.typeOfLeave = empLeavedata.typeOfLeave;
                leaveDto.empleavesId = empLeavedata.employeeLeavesId;
                empLeaveDataMap.get(empLeavedata.employeeId).set(empLeavedata.typeOfLeave, leaveDto);
            }
        });
        return empLeaveDataMap;
    }

    async getAllAvailableLeaves(req: GetEmpAvlLeaves): Promise<GetAllAvailableLeavesResponseModel> {
        const leavesEntityObj = await this.employeeLeavesRepository.findOne({ where: { year: req.year, employeeId: req.employeeId, typeOfLeave: req.typeOfLeave } });
        if (leavesEntityObj) {
            return new GetAllAvailableLeavesResponseModel(true, 123, '', leavesEntityObj.leavesAvailable);
        } else {
            const leaves = await this.leaveTypesService.getTypesOfLeavesById(req.typeOfLeave);
            return new GetAllAvailableLeavesResponseModel(true, 123, '', leaves.defaultLeaves);
        }
    }

    async updateConsumedLeaves(req: UpdateEmpAvlLeaves): Promise<CommonResponse> {
        const leavesEntityObj = await this.employeeLeavesRepository.findOne({ where: { year: req.year, employeeId: req.employeeId, typeOfLeave: req.typeOfLeave } });
        if (leavesEntityObj) {
            const update = await this.employeeLeavesRepository.update(
                {
                    year: req.year, employeeId: req.employeeId,
                    typeOfLeave: req.typeOfLeave
                },
                {
                    leavesUsed: Number(leavesEntityObj.leavesUsed) + Number(req.consumedLeaves),
                    leavesAvailable: Number(leavesEntityObj.leavesAvailable) - Number(req.consumedLeaves)
                });
        }
        return new CommonResponse(true, 1001, "Leaves updated Successfully. ");
    }

    async updateRejectedLeaves(req: UpdateEmpAvlLeaves): Promise<CommonResponse> {
        const leavesEntityObj = await this.employeeLeavesRepository.findOne({ where: { year: req.year, employeeId: req.employeeId, typeOfLeave: req.typeOfLeave } });
        if (leavesEntityObj) {
            const update = await this.employeeLeavesRepository.update(
                {
                    year: req.year, employeeId: req.employeeId,
                    typeOfLeave: req.typeOfLeave
                },
                {
                    leavesUsed: Number(leavesEntityObj.leavesUsed) - Number(req.consumedLeaves),
                    leavesAvailable: Number(leavesEntityObj.leavesAvailable) + Number(req.consumedLeaves)
                });
        }
        return new CommonResponse(true, 1001, "Leaves updated Successfully. ");
    }

    async getLeavesData(): Promise<EmployeeLeavesResponse> {
        const manager = getManager()
        const query =
            'SELECT  b.type_of_leave AS typesOfLeaves,leaves_available AS leavesLeftOver FROM ' + appSettings.hrms_db + '. employee_leaves AS a JOIN ' + appSettings.hrms_db + '. types_of_leaves AS  b ON a.type_of_leave = type_of_leave_id WHERE employee_id= "263" AND  type_of_leave_id NOT IN (5,7) ';
        const data = await manager.query(query);
        console.log(data);
        if (data.length > 0) {
            const respDtos = data.map(item => new EmployeeGetLeavesDto(item.typesOfLeaves, item.leavesLeftOver,));
            const response = new EmployeeLeavesResponse(true, 1122, 'Data retrived successfully', respDtos);
            return response;
        } else {
            return new EmployeeLeavesResponse(false, 11, 'Data not found');
        }

    }

    async HolidayCalander(): Promise<CommonResponse> {
        try {
            const manager = getManager();
            const query = 'SELECT holiday_id AS id,holiday_name AS title,DATE(holiday_date) AS start,DATE(holiday_date) AS end FROM ' + appSettings.hrms_db + '.holidays_calendar';
            const result = await manager.query(query)
            if (result) {
                return new CommonResponse(true, 1111, "Data retreived sucesssfuly", result)
            } else {
                return new CommonResponse(false, 1111, "Error occure")

            }

        } catch (err) {
            return err;
        }

    }
}
